import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { Row, Col, Form, Input, Button, message } from "antd";
import { apiPostContactUs } from "api";

const Corporation = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const onFinish = async (value) => {
    setIsLoading(true);
    try {
      const res = await apiPostContactUs(value);
      message.success("聯繫表單成功送出");
    } catch (error) {
      message.error(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <div className="w-full pt-20 mb-20">
        <h3 className="mb-1">{t("corporate.inPartnership")}</h3>
        <p className="text-SKF-G-002 m-0">
          {t("corporate.inPartnershipDescription")}
        </p>
      </div>
      <div className="w-full pb-20">
        <Row>
          <Col
            sm={{ span: 10, offset: 1 }}
            xs={{ span: 22, offset: 1 }}
            lg={{ span: 8, offset: 3 }}
            className="mb-10 desktop:mb-0"
          >
            <div className="bg-[url('assets/corporation/left.png')] h-320 rounded-3xl"></div>
            <h4 className="text-left mb-0">{t("corporate.customize")}</h4>
            <p className="text-left mt-0 text-SKF-G-001">
              {t("corporate.customizeDescription")}
            </p>
          </Col>
          <Col
            sm={{ span: 10, offset: 2 }}
            xs={{ span: 22, offset: 1 }}
            lg={{ span: 8, offset: 2 }}
          >
            <div className="bg-[url('assets/corporation/right.png')] h-320 rounded-3xl"></div>
            <h4 className="text-left mb-0">{t("corporate.adContract")}</h4>
            <p className="text-left mt-0 text-SKF-G-001">
              {t("corporate.adContractDescription")}
            </p>
          </Col>
        </Row>
      </div>
      <div className="w-full bg-SKF-G-001 px-4 desktop:px-56 py-6 desktop:py-12 tablet:px-20">
        <h4 className="text-left text-black">{t("common.contactUs")}</h4>
        <Form
          layout="vertical"
          name="contact"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Row gutter={16}>
            <Col sm={{ span: 12 }} xs={{ span: 24 }} className="mb-4">
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    message: t("common.form.requireMessage"),
                  },
                ]}
              >
                <Input placeholder={t("corporate.form.firstName")} size="large" className="p-2" />
              </Form.Item>
            </Col>
            <Col sm={{ span: 12 }} xs={{ span: 24 }} className="mb-4">
              <Form.Item
                name="email"
                rules={[
                  {
                    type: "email",
                    required: true,
                    message: t("common.form.emailRequiredMsg"),
                  },
                ]}
              >
                <Input placeholder={t("corporate.form.email")} size="large" className="p-2" />
              </Form.Item>
            </Col>
            <Col sm={{ span: 24 }} xs={{ span: 24 }} className="mb-4">
              <Form.Item
                name="phone"
                rules={[
                  {
                    required: true,
                    message: t("common.form.requireMessage"),
                  },
                ]}
              >
                <Input
                  placeholder="phone number"
                  size="large"
                  className="p-2"
                />
              </Form.Item>
            </Col>
            <Col sm={{ span: 24 }} xs={{ span: 24 }}>
              <Form.Item
                name="content"
                rules={[
                  {
                    required: true,
                    message: t("common.form.requireMessage"),
                  },
                ]}
              >
                <Input.TextArea
                  autoSize={{
                    minRows: 5,
                  }}
                  placeholder={t("corporate.form.content")}
                  size="large"
                  className="p-2"
                />
              </Form.Item>
            </Col>
            <Col
              sm={{ span: 24, offset: 0 }}
              xs={{ span: 24, offset: 0 }}
              className="text-left"
            >
              <Form.Item>
                <Button
                  htmlType="submit"
                  className="bg-black text-white py-2 px-5 h-auto"
                >
                  {t("common.form.submit")}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default Corporation;
